export default __webpack_public_path__ + "static/media/c.867c839c.png";